import * as XLSX from 'xlsx';

/* 엑셀파일 다운로드 함수
 * data : object [{}]
 */
export const downloadExcelFile = (data, excelFileName, sheetName, additionalSheetInfo = {}) => {
	const datas = XLSX.utils.json_to_sheet(data);
	const workbook = XLSX.utils.book_new();
	XLSX.utils.book_append_sheet(workbook, datas, sheetName);

	// 추가적인 시트 정보
	if(Array.isArray(additionalSheetInfo.data) && additionalSheetInfo.data.length > 0) {
		const sheetData = XLSX.utils.json_to_sheet(additionalSheetInfo.data);
		XLSX.utils.book_append_sheet(workbook, sheetData, additionalSheetInfo.sheetName);
	}

	XLSX.writeFile(workbook, excelFileName);
};